import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export const FreqParametriInline = ({ ospiteId, freq = 0, nome = "" }) => {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(freq ? String(freq) : "");
  const [busy, setBusy] = useState(false);
  const cur = Number(freq || 0);
  const save = async () => {
    setBusy(true);
    try {
      const n = val === "" ? 0 : Math.max(0, Math.round(Number(val)));
      await api.put(`/ospiti/${ospiteId}`, { parametri_frequenza_giorni: n });
      qc.invalidateQueries({ queryKey: ["parametri"] });
      qc.invalidateQueries({ queryKey: ["parametri-day"] });
      qc.invalidateQueries({ queryKey: ["parametri-da-misurare"] });
      qc.invalidateQueries({ queryKey: ["mod", "ospiti"] });
      toast.success(n > 0 ? `Programmato ogni ${n} giorni` : "Programmazione rimossa");
      setOpen(false);
    } catch { toast.error("Errore"); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={(e) => { e.stopPropagation(); setVal(cur ? String(cur) : ""); setOpen(true); }}
        title="Imposta ogni quanti giorni misurare i parametri"
        data-testid={`par-freq-set-${ospiteId}`}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold rounded-full px-1.5 py-0.5 border transition-colors ${cur > 0 ? "bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100" : "bg-transparent text-muted-foreground border-dashed border-muted-foreground/40 hover:bg-secondary"}`}>
        <CalendarClock size={10} />{cur > 0 ? `ogni ${cur}g` : "programma"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="par-freq-dialog">
          <DialogHeader>
            <DialogTitle>Programmazione parametri — {nome}</DialogTitle>
            <DialogDescription>Ogni quanti giorni vanno misurati i parametri. L'ospite comparirà nel box "Parametri da misurare oggi" quando la misura è scaduta. Lascia vuoto o 0 per non programmare.</DialogDescription>
          </DialogHeader>
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">Ogni</span>
            <Input type="number" min="0" step="1" value={val} onChange={(e) => setVal(e.target.value)} className="w-24 h-9" placeholder="es. 7" data-testid="par-freq-dialog-input" autoFocus />
            <span className="text-sm text-muted-foreground">giorni</span>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button onClick={save} disabled={busy} data-testid="par-freq-dialog-save">Salva</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
